import React from 'react'
import ReactDOM from 'react-dom'
import Router from './routes'

import './index.css'
import 'react-toastify/dist/ReactToastify.css'

ReactDOM.render(
  <Router/>,
  document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js